(function () {
  function addBtnClassToOmnisendButtons() {
    document.querySelectorAll('.omnisend-mobile-container button').forEach(function (button) {
      button.classList.add('btn');
    });
  }

  var observer = new MutationObserver(function () {
    addBtnClassToOmnisendButtons();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  addBtnClassToOmnisendButtons();
})();
